import React from 'react'

export default function RoundSkelton() {
    return (
        <div className='row'>
            <div className="col-lg-3">
                <div className="card-skl main-skl">
                    <div className="card-img-skl skeleton round-skelton">
                    </div>
                    <div className="card-body-skl circle-skelton">
                        <p className="card-intro-skl skeleton-w">
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-lg-3">
                <div className="card-skl main-skl hide-skl">
                    <div className="card-img-skl skeleton round-skelton">
                    </div>
                    <div className="card-body-skl circle-skelton">
                        <p className="card-intro-skl skeleton-w">
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-lg-3">
                <div className="card-skl main-skl hide-skl">
                    <div className="card-img-skl skeleton round-skelton">
                    </div>
                    <div className="card-body-skl circle-skelton">
                        <p className="card-intro-skl skeleton-w">
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-lg-3">
                <div className="card-skl main-skl hide-skl">
                    <div className="card-img-skl skeleton round-skelton">
                    </div>
                    <div className="card-body-skl circle-skelton">
                        <p className="card-intro-skl skeleton-w">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
